import { lazy, Suspense } from 'react'

import AboutSection from '#/features/home/components/AboutSection'
import CoursesSection from '#/features/home/components/CoursesSection'
import HeroSection from '#/features/home/components/HeroSection'
import ServicesSection from '#/features/home/components/ServicesSection'
import PageTransition from '#/components/common/PageTransition'

const AboutPillarsSection = lazy(
  () => import('#/features/about/components/AboutPillarsSection'),
)
const BlogSection = lazy(() => import('#/features/home/components/BlogSection'))

export default function HomePage() {
  return (
    <PageTransition>
      <main className="flex relative flex-col">
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <CoursesSection />
        <Suspense fallback={<div className="min-h-75" />}>
          <AboutPillarsSection />
        </Suspense>
        {/* <ProgramHighlightsSection /> */}
        <Suspense fallback={<div className="min-h-75" />}>
          <BlogSection />
        </Suspense>
      </main>
    </PageTransition>
  )
}

